import { Chip } from '@mui/material';

export default function BlogTags({ tags }: Readonly<{ tags: Array<string> }>) {
	if (!tags || tags.length === 0) {
		return null;
	}
	return (
		<div
			data-test-id="blog-tags-container"
			style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', pointerEvents: 'none' }}
		>
			{tags.map((tag: string, index) => {
				return (
					<Chip
						key={`${tag}-${index}`}
						label={tag}
						variant="default"
						clickable={false}
						data-test-id={`blog_${tag}`}
					></Chip>
				);
			})}
		</div>
	);
}
